<template>
  <div id="app" class="columns" :style="{'font-family': font+', sans-serif'}">
    <ArticleViewer v-if="activeArticle" v-bind:article="activeArticle" class="column is-three-quarters"></ArticleViewer>
    <ListOverview v-if="ArticleList" v-bind:activeArticle.sync="activeArticle" v-bind:ArticleList="ArticleList"></ListOverview>
  </div>
</template>

<script>
import WebFont from 'webfontloader';
import ArticleViewer from './components/ArticleViewer';
import ListOverview from './components/ListOverview';

import OldArticleList from './assets/articleList.json'
//import Labline from './assets/labline.json'
import {feeddata} from '../mainconfig/feeddata.js'

export default {
  name: 'app',
  components: {
    ArticleViewer,
    ListOverview
  },
  data: function(){
    return {
      activeArticle: null,
      font: null,
      ArticleList: null,
    }
  },
  watch: {
    activeArticle: function(newValue, oldValue){
      //Update url query param
      this.$router.push({query: {"article": newValue.urn, "internal-view": this.$route.query["internal-view"], "font": this.$route.query["font"], "font-provider": this.$route.query["font-provider"], "font-id": this.$route.query["font-id"]}});
    }
  },
  beforeCreate: function(){
    const font = this.$route.query["font"];
    const fontProvider = this.$route.query["font-provider"];

    if(font !== undefined){
      switch(fontProvider){
        case "google":
          WebFont.load({
            google: {
              families: [`${font}:400,bold,italic`]
            }
          })
        case "typekit":
          WebFont.load({
            typekit: {
              id: this.$route.query["font-id"]
            }
          })
      }
      this.font = font
    }

    fetch(feeddata["url"])
      .then(r => r.json())
      .then(data => {

        let relevantArticles = data["entries"].filter(d=>feeddata["rubrics"].indexOf(d["rubric_names"][0])>=0).sort((a, b) => {
          return a.version_created < b.version_created? 1 : -1
        })

        relevantArticles.forEach(d => {
          d["embed-infos"] = this.getEmbedInfos(d);
        });

        this.activeArticle = relevantArticles[0]

         //TOFIX: Move all articles to Ines
        OldArticleList.forEach(d => {
          if(relevantArticles.filter(e => e.headline == d.headline).length == 0){
            d["article_html"] = this.embedsToArticleHTML(d);
            d["associations"].forEach(e => {
              try{
                e["renditions"][0]["url"] = e["renditions"][0]["localUrl"];
              }catch{
                //Irrelevant.
              }
            });
            relevantArticles.push(d);
          }
        });


        this.ArticleList = relevantArticles;
        let article = this.$route.query["article"];
        if(article != undefined){
          let activeArticle = this.ArticleList.filter(d=> d["urn"]==article);
          if(activeArticle.length==1){
            this.activeArticle = activeArticle[0];
          }else{
            console.log("Artikel mit URN '"+article+"' nicht gefunden.");
          }
        }
      });
  },
  methods: {
    getEmbedInfos: function(articleData){
            let embedFlextags = articleData["categories"].filter(d => {
                return d["type"] == "dnltype:flextag" && d["qcode"] !== null && ["embed", "showcase"].indexOf(d["qcode"].split(".")[1]) >= 0
            });
            if(embedFlextags.length > 0){
                let embedInfos = {};
                for(let i = 0; i < embedFlextags.length;i++){
                    let qcodeAsArray = embedFlextags[i]["qcode"].split(".");
                    if(qcodeAsArray.length == 4){
                        embedInfos[qcodeAsArray.slice(-2)[0]] = qcodeAsArray.slice(-1)[0].replace("none", "-");
                    }else if(qcodeAsArray[1] == "showcase"){
                        embedInfos["importance"] = "top"
                    }else{
                        embedInfos["details"] = embedFlextags[i]["name"];
                    }
                }
                return embedInfos;
            }else{
                return undefined;
            }
        },
    embedsToArticleHTML(article){
      //Helper function converting manual collected articles to labline
      let enrichedArticle = article;
      let re = /<!-- \[(.+?)\] -->/g;
      let m;
          
      while((m = re.exec(article.article_html)) !== null) {
        let embedCode = m[1]
        let embedInfo = embedCode.split("-");
          try{
            if(embedInfo[0] == "gallery"){
              enrichedArticle.article_html = enrichedArticle.article_html.replace(m[0], "<dnl-gallery></dnl-gallery>");
            }else if(embedInfo[0] == "wg"){
              let assoc = article.associations.filter(d => d.urn==embedCode)[0].embed_html;
              let assocSrc = new DOMParser().parseFromString(assoc, "text/html").querySelector("div").getAttribute("data-pym-src");
              enrichedArticle.article_html = enrichedArticle.article_html.replace(m[0], "<p><a class='externalLink' href='"+assocSrc+"'>"+assocSrc+"</a></p>");
            }else if(embedInfo[0] == "dw"){
              let assoc = article.associations.filter(d => d.urn==embedCode)[0].embed_html;
              let assocSrc = new DOMParser().parseFromString(assoc, "text/html").querySelector("iframe").getAttribute("src");
              enrichedArticle.article_html = enrichedArticle.article_html.replace(m[0], "<p><a class='externalLink' href='"+assocSrc+"'>"+assocSrc+"</a></p>")
            }

          }catch(e){
            console.log("Error loading embed "+m.groups["embed"]);
            console.log(e);
            m = undefined;
          }
      }
      
      return enrichedArticle.article_html;
    }
  }
}
</script>
<style lang="scss">
@import "../node_modules/bulma/css/bulma.min.css";

#app.myriad_pro{
  //@import url("https://use.typekit.net/xva7ume.css");
  font-family: "myriad-pro", "Roboto", Arial, sans-serif;
}

#app.pt_sans{
  //@import url('https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');
  font-family: "PT Sans", sans-serif;
}

#app.source_sans_pro{
  //@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap');
  font-family: "Source Sans Pro", sans-serif; 
}

#app.sans_serif{
  font-family: sans-serif;
}


#app{
  margin: 0 auto 0 7.5vw;
  max-width: calc(100vw - 7.5vw);
}

@media (max-width: 786px){
  #app{
    display: flex;
    flex-direction: column-reverse;
    margin-left: auto;
    max-width: auto;
  }
}
</style>
